import { useState, useEffect, createContext, useContext } from "react";
const API = "https://ecommerce-api-skr3.onrender.com/api";

// ─── Product Image Helper ────────────────────────────────
const getProductImage = (name = "") => {
  const n = name.toLowerCase();
  if (n.includes("iphone") || n.includes("phone") || n.includes("mobile") || n.includes("samsung")) return "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400&q=80";
  if (n.includes("laptop") || n.includes("macbook") || n.includes("notebook") || n.includes("computer")) return "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&q=80";
  if (n.includes("headphone") || n.includes("earphone") || n.includes("audio") || n.includes("airpod")) return "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&q=80";
  if (n.includes("watch") || n.includes("smartwatch")) return "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&q=80";
  if (n.includes("tablet") || n.includes("ipad")) return "https://images.unsplash.com/photo-1544244015-0df4cec9a19c?w=400&q=80";
  if (n.includes("camera") || n.includes("canon") || n.includes("nikon")) return "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=400&q=80";
  if (n.includes("shoe") || n.includes("sneaker") || n.includes("nike") || n.includes("adidas")) return "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=80";
  if (n.includes("bag") || n.includes("backpack")) return "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&q=80";
  if (n.includes("shirt") || n.includes("clothing") || n.includes("jacket")) return "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80";
  if (n.includes("keyboard") || n.includes("gaming") || n.includes("mouse")) return "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=400&q=80";
  if (n.includes("speaker") || n.includes("bluetooth") || n.includes("sound")) return "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400&q=80";
  if (n.includes("tv") || n.includes("television")) return "https://images.unsplash.com/photo-1593359677879-a4bb92f829e1?w=400&q=80";
  if (n.includes("perfume") || n.includes("fragrance")) return "https://images.unsplash.com/photo-1541643600914-78b084683702?w=400&q=80";
  return "https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=400&q=80";
};

// ─── Auth Context ────────────────────────────────────────
const AuthContext = createContext(null);
const useAuth = () => useContext(AuthContext);
const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const login = (u, t) => { setUser(u); setToken(t); };
  const logout = () => { setUser(null); setToken(null); };
  return <AuthContext.Provider value={{ user, token, login, logout }}>{children}</AuthContext.Provider>;
};

// ─── API Helper ──────────────────────────────────────────
const apiFetch = async (path, options = {}, token = null) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { ...options, headers });
  return res.json();
};

// ─── Icons ───────────────────────────────────────────────
const Icon = ({ name, size = 20 }) => {
  const icons = {
    cart: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 01-8 0" /></svg>,
    orders: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>,
    home: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9,22 9,12 15,12 15,22" /></svg>,
    products: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="3" width="7" height="7" /><rect x="15" y="3" width="7" height="7" /><rect x="15" y="15" width="7" height="7" /><rect x="2" y="15" width="7" height="7" /></svg>,
    user: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    logout: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><polyline points="16,17 21,12 16,7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>,
    plus: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
    trash: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3,6 5,6 21,6" /><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" /><path d="M10 11v6M14 11v6M9 6V4h6v2" /></svg>,
    search: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>,
    star: <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" /></svg>,
    arrow: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12,5 19,12 12,19" /></svg>,
    check: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="20,6 9,17 4,12" /></svg>,
    close: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
    menu: <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>,
  };
  return <span style={{ display: "inline-flex", alignItems: "center" }}>{icons[name]}</span>;
};

// ─── Toast ───────────────────────────────────────────────
const Toast = ({ message, type, onClose }) => (
  <div style={{
    position: "fixed", bottom: 20, right: 20, left: 20, zIndex: 9999,
    maxWidth: 340, marginLeft: "auto",
    background: type === "error" ? "#1a1a1a" : "#FF6B2B",
    color: "#fff", padding: "14px 18px", borderRadius: 12,
    display: "flex", alignItems: "center", gap: 10,
    boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
    animation: "slideUp 0.3s ease",
    fontFamily: "'DM Sans', sans-serif", fontSize: 14, fontWeight: 500,
  }}>
    {type !== "error" && <Icon name="check" size={16} />}
    <span style={{ flex: 1 }}>{message}</span>
    <button onClick={onClose} style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", opacity: 0.7 }}>
      <Icon name="close" size={14} />
    </button>
  </div>
);

// ─── Navbar ──────────────────────────────────────────────
const Navbar = ({ page, setPage, cartCount }) => {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = ["home", "products", "cart", "orders"];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;800&family=DM+Sans:wght@300;400;500;600;700&display=swap');
        *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
        body { background: #fff; font-family: 'DM Sans', sans-serif; -webkit-font-smoothing: antialiased; }
        button { cursor: pointer; font-family: 'DM Sans', sans-serif; }
        input, select, textarea { font-family: 'DM Sans', sans-serif; }
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
        .card-hover { transition: transform 0.25s ease, box-shadow 0.25s ease; }
        .card-hover:hover { transform: translateY(-3px); box-shadow: 0 16px 48px rgba(0,0,0,0.12) !important; }
        .skeleton { background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%); background-size: 200% 100%; animation: shimmer 1.4s infinite; border-radius: 8px; }
        input:focus { border-color: #FF6B2B !important; background: #fff !important; outline: none; }

        /* ── Responsive breakpoints ── */
        @media (max-width: 900px) {
          .nav-links { display: none !important; }
          .nav-auth { display: none !important; }
          .nav-menu-btn { display: flex !important; }
          .hero-grid { display: none !important; }
          .features-grid { grid-template-columns: 1fr 1fr !important; }
          .cart-layout { grid-template-columns: 1fr !important; }
          .cart-summary { position: static !important; }
        }
        @media (max-width: 600px) {
          .features-grid { grid-template-columns: 1fr !important; }
          .hero-stats { gap: 20px !important; }
          .hero-btns { flex-direction: column !important; }
          .hero-btns button { width: 100% !important; justify-content: center !important; }
          .cta-banner { flex-direction: column !important; text-align: center !important; align-items: center !important; }
          .cta-banner button { width: 100% !important; justify-content: center !important; }
          .products-header { flex-direction: column !important; align-items: flex-start !important; }
          .products-controls { width: 100% !important; flex-direction: column !important; }
          .search-box { width: 100% !important; }
          .search-box input { width: 100% !important; }
          .add-product-btn { width: 100% !important; justify-content: center !important; }
          .cart-item { flex-wrap: wrap !important; }
          .order-header { flex-direction: column !important; align-items: flex-start !important; }
          .order-amount-row { width: 100% !important; justify-content: space-between !important; }
          .product-grid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)) !important; }
        }
      `}</style>

      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 500,
        background: "rgba(255,255,255,0.97)", backdropFilter: "blur(12px)",
        borderBottom: "1px solid #f0f0f0",
        height: 64, display: "flex", alignItems: "center",
        justifyContent: "space-between", padding: "0 20px",
      }}>
        {/* Logo */}
        <div onClick={() => { setPage("home"); setMenuOpen(false); }} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          <div style={{ width: 32, height: 32, background: "#FF6B2B", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 12px rgba(255,107,43,0.3)" }}>
            <span style={{ color: "#fff", fontSize: 16, fontWeight: 800, fontFamily: "'Playfair Display', serif" }}>S</span>
          </div>
          <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: "#1a1a1a", letterSpacing: "-0.5px" }}>ShopFlow</span>
        </div>

        {/* Desktop Nav */}
        <div className="nav-links" style={{ display: "flex", alignItems: "center", gap: 2 }}>
          {links.map(p => (
            <button key={p} onClick={() => setPage(p)} style={{
              background: page === p ? "#FFF0E8" : "none", border: "none",
              padding: "7px 14px", borderRadius: 8,
              color: page === p ? "#FF6B2B" : "#666",
              fontSize: 14, fontWeight: page === p ? 600 : 400,
              display: "flex", alignItems: "center", gap: 6,
              transition: "all 0.2s", position: "relative",
            }}>
              <Icon name={p} size={15} />
              <span style={{ textTransform: "capitalize" }}>{p}</span>
              {p === "cart" && cartCount > 0 && (
                <span style={{ position: "absolute", top: -3, right: -3, background: "#FF6B2B", color: "#fff", borderRadius: "50%", width: 17, height: 17, fontSize: 9, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{cartCount > 9 ? "9+" : cartCount}</span>
              )}
            </button>
          ))}
        </div>

        {/* Desktop Auth */}
        <div className="nav-auth" style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {user ? (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#f8f8f8", padding: "6px 12px", borderRadius: 8, border: "1px solid #f0f0f0" }}>
                <div style={{ width: 28, height: 28, background: "#FF6B2B", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 12, fontWeight: 700 }}>
                  {user.name?.charAt(0).toUpperCase()}
                </div>
                <span style={{ fontSize: 13, fontWeight: 500, color: "#333" }}>
                  {user.name}
                  {user.role === "admin" && <span style={{ color: "#FF6B2B", marginLeft: 4, fontSize: 10, fontWeight: 700 }}>ADMIN</span>}
                </span>
              </div>
              <button onClick={logout} style={{ background: "none", border: "1px solid #e8e8e8", padding: "6px 12px", borderRadius: 8, color: "#666", display: "flex", alignItems: "center", gap: 6, fontSize: 13, transition: "all 0.2s" }}>
                <Icon name="logout" size={14} /> Logout
              </button>
            </>
          ) : (
            <button onClick={() => setPage("auth")} style={{ background: "#FF6B2B", color: "#fff", border: "none", padding: "8px 20px", borderRadius: 8, fontSize: 14, fontWeight: 600, transition: "all 0.2s" }}>
              Sign In
            </button>
          )}
        </div>

        {/* Mobile: cart badge + hamburger */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button onClick={() => setPage("cart")} style={{ display: "none", background: "none", border: "none", position: "relative", padding: 4 }} className="nav-menu-btn" id="cart-mobile">
            <Icon name="cart" size={22} />
            {cartCount > 0 && <span style={{ position: "absolute", top: -2, right: -2, background: "#FF6B2B", color: "#fff", borderRadius: "50%", width: 16, height: 16, fontSize: 9, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{cartCount}</span>}
          </button>
          <button className="nav-menu-btn" onClick={() => setMenuOpen(!menuOpen)} style={{ display: "none", background: "none", border: "1px solid #e8e8e8", padding: "7px", borderRadius: 8, color: "#1a1a1a", alignItems: "center", justifyContent: "center" }}>
            {menuOpen ? <Icon name="close" size={18} /> : <Icon name="menu" size={18} />}
          </button>
        </div>
      </nav>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div style={{ position: "fixed", top: 64, left: 0, right: 0, zIndex: 499, background: "#fff", borderBottom: "1px solid #f0f0f0", padding: "12px 20px 20px", boxShadow: "0 8px 24px rgba(0,0,0,0.08)", animation: "fadeIn 0.2s ease" }}>
          {links.map(p => (
            <button key={p} onClick={() => { setPage(p); setMenuOpen(false); }} style={{
              width: "100%", background: page === p ? "#FFF0E8" : "none",
              border: "none", padding: "12px 14px", borderRadius: 10, marginBottom: 4,
              color: page === p ? "#FF6B2B" : "#333",
              fontSize: 15, fontWeight: page === p ? 600 : 400,
              display: "flex", alignItems: "center", gap: 10, textAlign: "left",
            }}>
              <Icon name={p} size={18} />
              <span style={{ textTransform: "capitalize", flex: 1 }}>{p}</span>
              {p === "cart" && cartCount > 0 && <span style={{ background: "#FF6B2B", color: "#fff", borderRadius: 20, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{cartCount}</span>}
            </button>
          ))}
          <div style={{ borderTop: "1px solid #f0f0f0", marginTop: 8, paddingTop: 12 }}>
            {user ? (
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 4px", marginBottom: 10 }}>
                  <div style={{ width: 34, height: 34, background: "#FF6B2B", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700 }}>{user.name?.charAt(0).toUpperCase()}</div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{user.name}</div>
                    <div style={{ fontSize: 11, color: "#FF6B2B", fontWeight: 600 }}>{user.role?.toUpperCase()}</div>
                  </div>
                </div>
                <button onClick={() => { logout(); setMenuOpen(false); }} style={{ width: "100%", background: "#f8f8f8", border: "none", padding: "12px", borderRadius: 10, fontSize: 14, fontWeight: 500, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, color: "#333" }}>
                  <Icon name="logout" size={16} /> Logout
                </button>
              </div>
            ) : (
              <button onClick={() => { setPage("auth"); setMenuOpen(false); }} style={{ width: "100%", background: "#FF6B2B", color: "#fff", border: "none", padding: "13px", borderRadius: 10, fontSize: 15, fontWeight: 600 }}>
                Sign In
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

// ─── Home Page ───────────────────────────────────────────
const HomePage = ({ setPage }) => {
  const features = [
    { icon: "🛡️", title: "Secure Payments", desc: "JWT protected, end-to-end encrypted transactions." },
    { icon: "⚡", title: "Fast Delivery", desc: "Real-time order tracking from checkout to door." },
    { icon: "🎯", title: "Best Prices", desc: "Competitive pricing on every single product." },
    { icon: "💬", title: "24/7 Support", desc: "Always here whenever you need assistance." },
  ];

  return (
    <div style={{ paddingTop: 64 }}>
      {/* ── Hero ── */}
      <div style={{
        minHeight: "calc(100vh - 64px)",
        background: "linear-gradient(150deg, #fffbf9 0%, #fff 55%, #fff5ee 100%)",
        padding: "48px 20px", display: "flex", alignItems: "center",
        position: "relative", overflow: "hidden",
      }}>
        {/* BG decoration */}
        <div style={{ position: "absolute", right: "5%", top: "15%", width: "min(500px, 50vw)", height: "min(500px, 50vw)", background: "radial-gradient(circle, rgba(255,107,43,0.07) 0%, transparent 70%)", borderRadius: "50%", pointerEvents: "none" }} />
        <div style={{ position: "absolute", right: "18%", top: "20%", width: "min(300px, 30vw)", height: "min(300px, 30vw)", border: "1px solid rgba(255,107,43,0.1)", borderRadius: "50%", pointerEvents: "none" }} />

        <div style={{ maxWidth: 1200, margin: "0 auto", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 40 }}>
          {/* Text content */}
          <div style={{ flex: "1 1 300px", maxWidth: 600, animation: "fadeUp 0.6s ease both" }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#FFF0E8", border: "1px solid rgba(255,107,43,0.2)", padding: "6px 14px", borderRadius: 20, marginBottom: 24 }}>
              <span style={{ width: 7, height: 7, background: "#FF6B2B", borderRadius: "50%", display: "inline-block", flexShrink: 0 }} />
              <span style={{ fontSize: 11, color: "#FF6B2B", fontWeight: 700, letterSpacing: "0.8px", textTransform: "uppercase", whiteSpace: "nowrap" }}>✦ New Collection Available</span>
            </div>

            <h1 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "clamp(36px, 7vw, 72px)",
              fontWeight: 800, color: "#1a1a1a",
              lineHeight: 1.08, marginBottom: 20, letterSpacing: "-2px",
            }}>
              Shop Smarter,<br />
              <span style={{ color: "#FF6B2B", fontStyle: "italic" }}>Live Better.</span>
            </h1>

            <p style={{ fontSize: "clamp(14px, 2vw, 17px)", color: "#666", lineHeight: 1.75, marginBottom: 32, maxWidth: 460 }}>
              Discover thousands of products at unbeatable prices. Your perfect shopping experience starts here.
            </p>

            <div className="hero-btns" style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button onClick={() => setPage("products")} style={{
                background: "#FF6B2B", color: "#fff", border: "none",
                padding: "14px 28px", borderRadius: 12, fontSize: 15, fontWeight: 600,
                display: "flex", alignItems: "center", gap: 8,
                boxShadow: "0 6px 20px rgba(255,107,43,0.3)", transition: "all 0.2s",
              }}>
                Shop Now <Icon name="arrow" size={17} />
              </button>
              <button onClick={() => setPage("orders")} style={{
                background: "#fff", color: "#1a1a1a", border: "1.5px solid #e8e8e8",
                padding: "14px 28px", borderRadius: 12, fontSize: 15, fontWeight: 500, transition: "all 0.2s",
              }}>
                View Orders
              </button>
            </div>

            {/* Stats */}
            <div className="hero-stats" style={{ display: "flex", gap: 32, marginTop: 44, flexWrap: "wrap" }}>
              {[["10K+", "Products"], ["50K+", "Customers"], ["4.9★", "Rating"]].map(([num, label]) => (
                <div key={label}>
                  <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(22px, 3vw, 30px)", fontWeight: 700, color: "#1a1a1a", lineHeight: 1 }}>{num}</div>
                  <div style={{ fontSize: 12, color: "#999", marginTop: 3 }}>{label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right product grid — hidden on mobile via CSS */}
          <div className="hero-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, flexShrink: 0 }}>
            {[
              { emoji: "📱", bg: "#FFF0E8" }, { emoji: "💻", bg: "#EEF2FF" },
              { emoji: "🎧", bg: "#ECFDF5" }, { emoji: "⌚", bg: "#FFF0E8" },
            ].map((item, i) => (
              <div key={i} onClick={() => setPage("products")} style={{
                width: 110, height: 110, background: item.bg,
                borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 42, border: "1px solid rgba(0,0,0,0.05)",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                transform: i % 2 !== 0 ? "translateY(14px)" : "none",
                animation: `float ${3 + i * 0.4}s ease-in-out infinite`,
                cursor: "pointer",
              }}>{item.emoji}</div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Features ── */}
      <div style={{ padding: "72px 20px", background: "#fff" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(26px, 5vw, 42px)", fontWeight: 700, color: "#1a1a1a", letterSpacing: "-1px", marginBottom: 10 }}>
              Why Choose ShopFlow?
            </h2>
            <p style={{ color: "#999", fontSize: 15 }}>Everything you need for a perfect shopping experience.</p>
          </div>

          <div className="features-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
            {features.map((f, i) => (
              <div key={i} className="card-hover" style={{ padding: "28px 22px", background: "#fafafa", borderRadius: 16, border: "1px solid #f0f0f0" }}>
                <div style={{ fontSize: 34, marginBottom: 14 }}>{f.icon}</div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a", marginBottom: 8 }}>{f.title}</h3>
                <p style={{ fontSize: 13, color: "#999", lineHeight: 1.65 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── CTA Banner ── */}
      <div style={{ padding: "0 20px 72px" }}>
        <div className="cta-banner" style={{
          maxWidth: 1100, margin: "0 auto",
          background: "#1a1a1a", borderRadius: 20, padding: "48px 40px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          gap: 24, flexWrap: "wrap", position: "relative", overflow: "hidden",
        }}>
          <div style={{ position: "absolute", right: -40, top: -40, width: 250, height: 250, background: "radial-gradient(circle, rgba(255,107,43,0.12) 0%, transparent 70%)", borderRadius: "50%", pointerEvents: "none" }} />
          <div style={{ position: "relative" }}>
            <div style={{ fontSize: 11, color: "#FF6B2B", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", marginBottom: 12 }}>✦ Limited Time</div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(22px, 4vw, 36px)", fontWeight: 700, color: "#fff", letterSpacing: "-0.5px", marginBottom: 8 }}>
              Ready to start shopping?
            </h2>
            <p style={{ color: "#888", fontSize: 15 }}>Join thousands of happy customers today.</p>
          </div>
          <button onClick={() => setPage("products")} style={{
            background: "#FF6B2B", color: "#fff", border: "none",
            padding: "15px 32px", borderRadius: 12, fontSize: 15, fontWeight: 600,
            display: "flex", alignItems: "center", gap: 8,
            boxShadow: "0 6px 24px rgba(255,107,43,0.4)", position: "relative", flexShrink: 0,
          }}>
            Browse Products <Icon name="arrow" size={17} />
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Auth Page ───────────────────────────────────────────
const AuthPage = ({ setPage, showToast }) => {
  const { login } = useAuth();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.email || !form.password) { showToast("Please fill all fields", "error"); return; }
    setLoading(true);
    try {
      const path = mode === "login" ? "/auth/login" : "/auth/register";
      const body = mode === "login" ? { email: form.email, password: form.password } : form;
      const data = await apiFetch(path, { method: "POST", body: JSON.stringify(body) });
      if (data.token) {
        login(data.user, data.token);
        showToast(`Welcome, ${data.user.name}! 🎉`);
        setPage("products");
      } else if (data.user && mode === "register") {
        showToast("Account created! Please sign in.");
        setMode("login");
      } else {
        showToast(data.message || "Something went wrong", "error");
      }
    } catch { showToast("Connection error", "error"); }
    setLoading(false);
  };

  const inp = { padding: "12px 14px", borderRadius: 10, border: "1.5px solid #e8e8e8", fontSize: 14, color: "#1a1a1a", background: "#fafafa", width: "100%", transition: "border 0.2s" };

  return (
    <div style={{ minHeight: "100vh", paddingTop: 64, background: "linear-gradient(150deg, #fffbf9, #fff)", display: "flex", alignItems: "center", justifyContent: "center", padding: "80px 16px 40px" }}>
      <div style={{ background: "#fff", borderRadius: 20, padding: "clamp(24px,5vw,44px)", width: "100%", maxWidth: 420, boxShadow: "0 12px 48px rgba(0,0,0,0.09)", border: "1px solid #f0f0f0", animation: "fadeUp 0.5s ease" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, background: "#FF6B2B", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", boxShadow: "0 6px 20px rgba(255,107,43,0.3)" }}>
            <Icon name="user" size={24} />
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 28, fontWeight: 700, color: "#1a1a1a", marginBottom: 6 }}>
            {mode === "login" ? "Welcome back" : "Create account"}
          </h2>
          <p style={{ color: "#999", fontSize: 14 }}>{mode === "login" ? "Sign in to continue shopping" : "Join ShopFlow today"}</p>
        </div>

        <div style={{ display: "flex", background: "#f5f5f5", borderRadius: 10, padding: 4, marginBottom: 24 }}>
          {["login", "register"].map(m => (
            <button key={m} onClick={() => setMode(m)} style={{
              flex: 1, padding: "9px 0",
              background: mode === m ? "#fff" : "none", border: "none", borderRadius: 8,
              fontSize: 14, fontWeight: mode === m ? 600 : 400,
              color: mode === m ? "#1a1a1a" : "#999",
              boxShadow: mode === m ? "0 1px 4px rgba(0,0,0,0.08)" : "none",
              transition: "all 0.2s", textTransform: "capitalize",
            }}>{m === "login" ? "Sign In" : "Register"}</button>
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {mode === "register" && <input placeholder="Full name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inp} />}
          <input placeholder="Email address" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={inp} />
          <input placeholder="Password" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} onKeyDown={e => e.key === "Enter" && handleSubmit()} style={inp} />
          <button onClick={handleSubmit} disabled={loading} style={{
            background: loading ? "#ffa07a" : "#FF6B2B", color: "#fff", border: "none",
            padding: "14px", borderRadius: 10, fontSize: 15, fontWeight: 600, marginTop: 6,
            boxShadow: "0 4px 16px rgba(255,107,43,0.25)", transition: "all 0.2s",
          }}>
            {loading ? "Please wait..." : mode === "login" ? "Sign In" : "Create Account"}
          </button>
        </div>

        <p style={{ textAlign: "center", marginTop: 18, fontSize: 13, color: "#999" }}>
          {mode === "login" ? "Don't have an account? " : "Already have an account? "}
          <span onClick={() => setMode(mode === "login" ? "register" : "login")} style={{ color: "#FF6B2B", fontWeight: 600, cursor: "pointer" }}>
            {mode === "login" ? "Register" : "Sign In"}
          </span>
        </p>
      </div>
    </div>
  );
};

// ─── Product Card ─────────────────────────────────────────
const ProductCard = ({ product: p, addingId, isAdmin, onAddToCart, onEdit, onDelete }) => {
  const [imgErr, setImgErr] = useState(false);
  return (
    <div className="card-hover" style={{ background: "#fff", borderRadius: 16, border: "1px solid #f0f0f0", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
      <div style={{ position: "relative", height: 190, overflow: "hidden" }}>
        <img
          src={imgErr ? "https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=400&q=80" : getProductImage(p.name)}
          alt={p.name} onError={() => setImgErr(true)}
          style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.4s ease" }}
          onMouseEnter={e => e.target.style.transform = "scale(1.05)"}
          onMouseLeave={e => e.target.style.transform = "scale(1)"}
        />
        {p.stock === 0 && <span style={{ position: "absolute", top: 10, right: 10, background: "rgba(17,17,17,0.85)", color: "#fff", padding: "3px 9px", borderRadius: 6, fontSize: 10, fontWeight: 700, backdropFilter: "blur(4px)" }}>Sold Out</span>}
        {p.stock > 0 && p.stock <= 5 && <span style={{ position: "absolute", top: 10, right: 10, background: "rgba(255,107,43,0.9)", color: "#fff", padding: "3px 9px", borderRadius: 6, fontSize: 10, fontWeight: 700 }}>Only {p.stock} left</span>}
        {isAdmin && (
          <div style={{ position: "absolute", top: 10, left: 10, display: "flex", gap: 6 }}>
            <button onClick={onEdit} style={{ background: "rgba(255,255,255,0.95)", border: "none", width: 30, height: 30, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", color: "#333", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}>✏️</button>
            <button onClick={onDelete} style={{ background: "rgba(255,255,255,0.95)", border: "none", width: 30, height: 30, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", color: "#e74c3c", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}><Icon name="trash" size={13} /></button>
          </div>
        )}
      </div>
      <div style={{ padding: "14px 16px 16px", flex: 1, display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 6, marginBottom: 6 }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a", lineHeight: 1.3, flex: 1, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{p.name}</h3>
          <div style={{ display: "flex", gap: 1, flexShrink: 0 }}>
            {[...Array(5)].map((_, i) => <span key={i} style={{ color: i < 4 ? "#FF6B2B" : "#e0e0e0", fontSize: 10 }}>★</span>)}
          </div>
        </div>
        <p style={{ fontSize: 12, color: "#aaa", marginBottom: 12, flex: 1, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", lineHeight: 1.5 }}>{p.description || "Premium quality product."}</p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
          <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: "#1a1a1a" }}>${parseFloat(p.price).toFixed(2)}</span>
          <span style={{ fontSize: 11, fontWeight: 600, color: p.stock > 10 ? "#22c55e" : p.stock > 0 ? "#FF6B2B" : "#e74c3c", background: p.stock > 10 ? "#f0fdf4" : p.stock > 0 ? "#fff0e8" : "#fff0f0", padding: "3px 8px", borderRadius: 6 }}>
            {p.stock > 0 ? `${p.stock} in stock` : "Sold out"}
          </span>
        </div>
        <button onClick={() => onAddToCart(p.id)} disabled={p.stock === 0 || addingId === p.id} style={{
          width: "100%", padding: "10px",
          background: p.stock === 0 ? "#f5f5f5" : addingId === p.id ? "#ffa07a" : "#FF6B2B",
          color: p.stock === 0 ? "#999" : "#fff",
          border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600,
          display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
          transition: "all 0.2s", cursor: p.stock === 0 ? "not-allowed" : "pointer",
        }}>
          {addingId === p.id ? "Adding..." : p.stock === 0 ? "Out of Stock" : <><Icon name="cart" size={14} /> Add to Cart</>}
        </button>
      </div>
    </div>
  );
};

// ─── Products Page ───────────────────────────────────────
const ProductsPage = ({ showToast }) => {
  const { token, user } = useAuth();
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", description: "", price: "", stock: "" });
  const [editId, setEditId] = useState(null);
  const [addingId, setAddingId] = useState(null);

  const loadProducts = async (q = search) => {
    setLoading(true);
    const data = await apiFetch(`/products?search=${q}&limit=50`);
    setProducts(data.products || []);
    setLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadProducts(); }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = setTimeout(() => loadProducts(search), 400);
    return () => clearTimeout(t);
  }, [search]);

  const handleAddToCart = async (productId) => {
    if (!token) { showToast("Please sign in first", "error"); return; }
    setAddingId(productId);
    const data = await apiFetch("/cart", { method: "POST", body: JSON.stringify({ product_id: productId, quantity: 1 }) }, token);
    if (data.cart) showToast("Added to cart! 🛒");
    else showToast(data.message || "Error", "error");
    setAddingId(null);
  };

  const handleSave = async () => {
    if (!form.name || !form.price) { showToast("Name and price required", "error"); return; }
    const path = editId ? `/products/${editId}` : "/products";
    const method = editId ? "PUT" : "POST";
    const data = await apiFetch(path, { method, body: JSON.stringify(form) }, token);
    if (data.product) {
      showToast(editId ? "Product updated!" : "Product created!");
      setShowForm(false); setForm({ name: "", description: "", price: "", stock: "" }); setEditId(null);
      loadProducts();
    } else showToast(data.message || "Error", "error");
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    await apiFetch(`/products/${id}`, { method: "DELETE" }, token);
    showToast("Product deleted!"); loadProducts();
  };

  const inp = { padding: "11px 14px", borderRadius: 10, border: "1.5px solid #e8e8e8", fontSize: 14, color: "#1a1a1a", background: "#fafafa", width: "100%", transition: "border 0.2s" };

  return (
    <div style={{ paddingTop: 64, minHeight: "100vh", background: "#fafafa" }}>
      {/* Header */}
      <div style={{ background: "#fff", padding: "28px 20px", borderBottom: "1px solid #f0f0f0" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div className="products-header" style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 11, color: "#FF6B2B", fontWeight: 700, letterSpacing: "0.8px", textTransform: "uppercase", marginBottom: 6 }}>Our Collection</div>
              <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(24px, 5vw, 40px)", fontWeight: 700, color: "#1a1a1a", letterSpacing: "-1px" }}>Products</h1>
              <p style={{ color: "#999", fontSize: 13, marginTop: 4 }}>{loading ? "Loading..." : `${products.length} items available`}</p>
            </div>
            <div className="products-controls" style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              <div className="search-box" style={{ display: "flex", alignItems: "center", gap: 8, background: "#f5f5f5", padding: "10px 14px", borderRadius: 10, border: "1.5px solid #e8e8e8", flex: "1 1 200px" }}>
                <Icon name="search" size={15} />
                <input placeholder="Search products..." value={search} onChange={e => setSearch(e.target.value)}
                  style={{ border: "none", background: "none", fontSize: 14, color: "#1a1a1a", width: "100%", minWidth: 0 }} />
                {search && <button onClick={() => setSearch("")} style={{ background: "none", border: "none", color: "#999", padding: 0, flexShrink: 0 }}><Icon name="close" size={13} /></button>}
              </div>
              {user?.role === "admin" && (
                <button className="add-product-btn" onClick={() => { setShowForm(true); setEditId(null); setForm({ name: "", description: "", price: "", stock: "" }); }} style={{
                  background: "#FF6B2B", color: "#fff", border: "none",
                  padding: "10px 16px", borderRadius: 10, fontSize: 14, fontWeight: 600,
                  display: "flex", alignItems: "center", gap: 6, flexShrink: 0,
                }}>
                  <Icon name="plus" size={15} /> Add Product
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Grid */}
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "28px 20px" }}>
        {loading ? (
          <div className="product-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 16 }}>
            {[...Array(8)].map((_, i) => (
              <div key={i} style={{ background: "#fff", borderRadius: 16, overflow: "hidden", border: "1px solid #f0f0f0" }}>
                <div className="skeleton" style={{ height: 190 }} />
                <div style={{ padding: 16 }}>
                  <div className="skeleton" style={{ height: 16, width: "65%", marginBottom: 10 }} />
                  <div className="skeleton" style={{ height: 13, marginBottom: 6 }} />
                  <div className="skeleton" style={{ height: 13, width: "55%", marginBottom: 18 }} />
                  <div className="skeleton" style={{ height: 38 }} />
                </div>
              </div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <div style={{ fontSize: 52, marginBottom: 14 }}>🛍️</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: "#1a1a1a", marginBottom: 8 }}>No products found</h3>
            <p style={{ color: "#999" }}>{search ? `No results for "${search}"` : "No products yet"}</p>
            {search && <button onClick={() => setSearch("")} style={{ marginTop: 16, background: "none", border: "1.5px solid #e8e8e8", padding: "10px 20px", borderRadius: 10, fontSize: 14, color: "#333" }}>Clear Search</button>}
          </div>
        ) : (
          <div className="product-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 16 }}>
            {products.map(p => (
              <ProductCard
                key={p.id} product={p}
                addingId={addingId}
                isAdmin={user?.role === "admin"}
                onAddToCart={handleAddToCart}
                onEdit={() => { setEditId(p.id); setForm({ name: p.name, description: p.description || "", price: p.price, stock: p.stock }); setShowForm(true); }}
                onDelete={() => handleDelete(p.id)}
              />
            ))}
          </div>
        )}
      </div>

      {/* Admin Modal */}
      {showForm && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)", animation: "fadeIn 0.2s ease" }}>
          <div style={{ background: "#fff", borderRadius: 20, padding: "clamp(24px,5vw,36px)", width: "100%", maxWidth: 460, boxShadow: "0 24px 64px rgba(0,0,0,0.15)", animation: "fadeUp 0.3s ease", maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
              <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: "#1a1a1a" }}>{editId ? "Edit Product" : "New Product"}</h3>
              <button onClick={() => setShowForm(false)} style={{ background: "#f5f5f5", border: "none", width: 34, height: 34, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#666" }}><Icon name="close" size={15} /></button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[["name", "Product Name", "text"], ["description", "Description", "text"], ["price", "Price ($)", "number"], ["stock", "Stock Quantity", "number"]].map(([key, label, type]) => (
                <div key={key}>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#888", letterSpacing: "0.4px", display: "block", marginBottom: 5 }}>{label.toUpperCase()}</label>
                  <input type={type} placeholder={label} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} style={inp} />
                </div>
              ))}
              {form.name && (
                <div style={{ display: "flex", gap: 10, alignItems: "center", background: "#fafafa", padding: "10px 12px", borderRadius: 10, border: "1px solid #f0f0f0" }}>
                  <img src={getProductImage(form.name)} alt="" style={{ width: 44, height: 44, objectFit: "cover", borderRadius: 8 }} onError={e => e.target.src = "https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=100&q=80"} />
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#333" }}>Auto Image Preview</div>
                    <div style={{ fontSize: 11, color: "#aaa" }}>Based on product name</div>
                  </div>
                </div>
              )}
              <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                <button onClick={() => setShowForm(false)} style={{ flex: 1, padding: "12px", borderRadius: 10, border: "1.5px solid #e8e8e8", background: "#fff", fontSize: 14 }}>Cancel</button>
                <button onClick={handleSave} style={{ flex: 1, padding: "12px", borderRadius: 10, background: "#FF6B2B", color: "#fff", border: "none", fontSize: 14, fontWeight: 600, boxShadow: "0 4px 14px rgba(255,107,43,0.3)" }}>
                  {editId ? "Update" : "Create Product"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── Cart Page ───────────────────────────────────────────
const CartPage = ({ setPage, showToast, setCartCount }) => {
  const { token } = useAuth();
  const [cart, setCart] = useState([]);
  const [grandTotal, setGrandTotal] = useState("0.00");
  const [loading, setLoading] = useState(true);
  const [placing, setPlacing] = useState(false);
  const [removingId, setRemovingId] = useState(null);

  const loadCart = async () => {
    if (!token) { setLoading(false); return; }
    setLoading(true);
    const data = await apiFetch("/cart", {}, token);
    setCart(data.cart || []); setGrandTotal(data.grandTotal || "0.00"); setCartCount(data.count || 0);
    setLoading(false);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadCart(); }, [token]);

  const removeItem = async (id) => {
    setRemovingId(id);
    await apiFetch(`/cart/${id}`, { method: "DELETE" }, token);
    showToast("Item removed"); loadCart(); setRemovingId(null);
  };

  const placeOrder = async () => {
    setPlacing(true);
    const data = await apiFetch("/orders", { method: "POST" }, token);
    if (data.order) { showToast("Order placed! 🎉"); setCartCount(0); setPage("orders"); }
    else showToast(data.message || "Error", "error");
    setPlacing(false);
  };

  if (!token) return (
    <div style={{ paddingTop: 64, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", flexDirection: "column", gap: 14, padding: "80px 20px", textAlign: "center" }}>
      <div style={{ fontSize: 60 }}>🔒</div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(22px,5vw,30px)", color: "#1a1a1a" }}>Please sign in</h2>
      <p style={{ color: "#999", fontSize: 15 }}>You need to be logged in to view your cart</p>
      <button onClick={() => setPage("auth")} style={{ background: "#FF6B2B", color: "#fff", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 15, fontWeight: 600, marginTop: 6 }}>Sign In</button>
    </div>
  );

  return (
    <div style={{ paddingTop: 64, minHeight: "100vh", background: "#fafafa" }}>
      <div style={{ background: "#fff", padding: "28px 20px", borderBottom: "1px solid #f0f0f0" }}>
        <div style={{ maxWidth: 1050, margin: "0 auto" }}>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(24px,5vw,40px)", fontWeight: 700, color: "#1a1a1a", letterSpacing: "-1px" }}>Your Cart</h1>
          <p style={{ color: "#999", fontSize: 13, marginTop: 4 }}>{cart.length} {cart.length === 1 ? "item" : "items"}</p>
        </div>
      </div>

      <div style={{ maxWidth: 1050, margin: "0 auto", padding: "24px 20px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "50px 0", color: "#999" }}>Loading cart...</div>
        ) : cart.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 16, padding: "clamp(36px,8vw,60px) 24px", textAlign: "center", border: "1px solid #f0f0f0" }}>
            <div style={{ fontSize: 56, marginBottom: 14 }}>🛒</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: "#1a1a1a", marginBottom: 8 }}>Cart is empty</h3>
            <p style={{ color: "#999", marginBottom: 22 }}>Add some products to get started</p>
            <button onClick={() => setPage("products")} style={{ background: "#FF6B2B", color: "#fff", border: "none", padding: "12px 24px", borderRadius: 10, fontSize: 14, fontWeight: 600 }}>Browse Products</button>
          </div>
        ) : (
          <div className="cart-layout" style={{ display: "grid", gridTemplateColumns: "1fr 300px", gap: 20, alignItems: "start" }}>
            {/* Items */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {cart.map(item => (
                <div key={item.id} className="cart-item" style={{ background: "#fff", borderRadius: 14, padding: "16px", border: "1px solid #f0f0f0", display: "flex", alignItems: "center", gap: 14 }}>
                  <div style={{ width: 70, height: 70, borderRadius: 10, overflow: "hidden", flexShrink: 0 }}>
                    <img src={getProductImage(item.name)} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={e => e.target.src = "https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=200&q=80"} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <h4 style={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a", marginBottom: 3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.name}</h4>
                    <p style={{ fontSize: 12, color: "#aaa" }}>${parseFloat(item.price).toFixed(2)} × {item.quantity}</p>
                  </div>
                  <div style={{ textAlign: "right", flexShrink: 0 }}>
                    <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: "#1a1a1a", marginBottom: 6 }}>${parseFloat(item.total_price).toFixed(2)}</div>
                    <button onClick={() => removeItem(item.id)} disabled={removingId === item.id} style={{ background: "#fff0f0", border: "none", borderRadius: 7, padding: "5px 10px", color: "#e74c3c", fontSize: 12, display: "flex", alignItems: "center", gap: 4 }}>
                      <Icon name="trash" size={12} /> Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Summary */}
            <div className="cart-summary" style={{ background: "#fff", borderRadius: 16, border: "1px solid #f0f0f0", overflow: "hidden", position: "sticky", top: 80 }}>
              <div style={{ padding: "16px 20px", background: "#fafafa", borderBottom: "1px solid #f0f0f0" }}>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1a1a1a" }}>Order Summary</h3>
              </div>
              <div style={{ padding: "16px 20px" }}>
                {cart.map(item => (
                  <div key={item.id} style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                    <span style={{ fontSize: 13, color: "#666", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>{item.name} ×{item.quantity}</span>
                    <span style={{ fontSize: 13, fontWeight: 500, color: "#333", flexShrink: 0, marginLeft: 8 }}>${parseFloat(item.total_price).toFixed(2)}</span>
                  </div>
                ))}
                <div style={{ borderTop: "1px solid #f0f0f0", marginTop: 12, paddingTop: 12, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <span style={{ fontSize: 15, fontWeight: 700 }}>Total</span>
                  <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: "#FF6B2B" }}>${grandTotal}</span>
                </div>
                <button onClick={placeOrder} disabled={placing} style={{ width: "100%", padding: "13px", background: placing ? "#ffa07a" : "#FF6B2B", color: "#fff", border: "none", borderRadius: 10, fontSize: 15, fontWeight: 600, boxShadow: "0 4px 16px rgba(255,107,43,0.3)" }}>
                  {placing ? "Placing Order..." : "Place Order 🎉"}
                </button>
                <button onClick={() => setPage("products")} style={{ width: "100%", padding: "11px", marginTop: 8, background: "none", border: "1.5px solid #e8e8e8", borderRadius: 10, fontSize: 14, color: "#666" }}>
                  Continue Shopping
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ─── Orders Page ─────────────────────────────────────────
const OrdersPage = ({ setPage, showToast }) => {
  const { token, user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingId, setUpdatingId] = useState(null);

  const loadOrders = async () => {
    if (!token) { setLoading(false); return; }
    setLoading(true);
    const path = user?.role === "admin" ? "/orders/all" : "/orders/my-orders";
    const data = await apiFetch(path, {}, token);
    setOrders(data.orders || []); setLoading(false);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadOrders(); }, [token]);

  const updateStatus = async (orderId, status) => {
    setUpdatingId(orderId);
    const data = await apiFetch(`/orders/${orderId}/status`, { method: "PUT", body: JSON.stringify({ status }) }, token);
    if (data.order) { showToast(`Status updated to ${status}`); loadOrders(); }
    else showToast(data.message || "Error", "error");
    setUpdatingId(null);
  };

  const statusColors = {
    pending: { bg: "#FFF8E8", color: "#D97706" },
    processing: { bg: "#EFF6FF", color: "#2563EB" },
    shipped: { bg: "#F0F9FF", color: "#0284C7" },
    delivered: { bg: "#F0FDF4", color: "#16A34A" },
    cancelled: { bg: "#FFF0F0", color: "#DC2626" },
  };

  if (!token) return (
    <div style={{ paddingTop: 64, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", flexDirection: "column", gap: 14, padding: "80px 20px", textAlign: "center" }}>
      <div style={{ fontSize: 60 }}>🔒</div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(22px,5vw,30px)", color: "#1a1a1a" }}>Please sign in</h2>
      <p style={{ color: "#999", fontSize: 15 }}>You need to be logged in to view orders</p>
      <button onClick={() => setPage("auth")} style={{ background: "#FF6B2B", color: "#fff", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 15, fontWeight: 600, marginTop: 6 }}>Sign In</button>
    </div>
  );

  return (
    <div style={{ paddingTop: 64, minHeight: "100vh", background: "#fafafa" }}>
      <div style={{ background: "#fff", padding: "28px 20px", borderBottom: "1px solid #f0f0f0" }}>
        <div style={{ maxWidth: 920, margin: "0 auto" }}>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(24px,5vw,40px)", fontWeight: 700, color: "#1a1a1a", letterSpacing: "-1px" }}>
            {user?.role === "admin" ? "All Orders" : "My Orders"}
          </h1>
          <p style={{ color: "#999", fontSize: 13, marginTop: 4 }}>{orders.length} {orders.length === 1 ? "order" : "orders"} found</p>
        </div>
      </div>

      <div style={{ maxWidth: 920, margin: "0 auto", padding: "24px 20px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "50px 0", color: "#999" }}>Loading orders...</div>
        ) : orders.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 16, padding: "clamp(36px,8vw,60px) 24px", textAlign: "center", border: "1px solid #f0f0f0" }}>
            <div style={{ fontSize: 56, marginBottom: 14 }}>📋</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: "#1a1a1a", marginBottom: 8 }}>No orders yet</h3>
            <p style={{ color: "#999", marginBottom: 22 }}>Start shopping to see your orders here</p>
            <button onClick={() => setPage("products")} style={{ background: "#FF6B2B", color: "#fff", border: "none", padding: "12px 24px", borderRadius: 10, fontSize: 14, fontWeight: 600 }}>Browse Products</button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {orders.map((order, idx) => {
              const sc = statusColors[order.status] || statusColors.pending;
              return (
                <div key={order.id} className="card-hover" style={{ background: "#fff", borderRadius: 16, border: "1px solid #f0f0f0", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.04)", animation: `fadeUp 0.4s ease ${idx * 0.07}s both` }}>
                  {/* Header */}
                  <div style={{ padding: "14px 20px", background: "#fafafa", borderBottom: "1px solid #f5f5f5" }}>
                    <div className="order-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a" }}>Order #{String(order.id).padStart(4, "0")}</span>
                        <span style={{ background: sc.bg, color: sc.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, textTransform: "capitalize" }}>{order.status}</span>
                        {user?.role === "admin" && order.customer_name && (
                          <span style={{ background: "#f0f0f0", color: "#555", padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500 }}>👤 {order.customer_name}</span>
                        )}
                      </div>
                      <div className="order-amount-row" style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: "#1a1a1a" }}>${parseFloat(order.total_price).toFixed(2)}</span>
                        {user?.role === "admin" && (
                          <select value={order.status} onChange={e => updateStatus(order.id, e.target.value)} disabled={updatingId === order.id}
                            style={{ padding: "6px 10px", borderRadius: 8, border: "1.5px solid #e8e8e8", background: "#fff", fontSize: 12, color: "#333", cursor: "pointer" }}>
                            {["pending", "processing", "shipped", "delivered", "cancelled"].map(s => (
                              <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
                            ))}
                          </select>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Items */}
                  <div style={{ padding: "14px 20px" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                      {(order.items || []).map((item, i) => (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, background: "#fafafa", border: "1px solid #f0f0f0", borderRadius: 8, padding: "7px 10px" }}>
                          <div style={{ width: 30, height: 30, borderRadius: 6, overflow: "hidden", flexShrink: 0 }}>
                            <img src={getProductImage(item.name || "")} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={e => e.target.src = "https://images.unsplash.com/photo-1560393464-5c69a73c5770?w=100&q=80"} />
                          </div>
                          <div>
                            <div style={{ fontSize: 12, fontWeight: 600, color: "#333" }}>{item.name}</div>
                            <div style={{ fontSize: 11, color: "#aaa" }}>×{item.quantity} · ${parseFloat(item.price).toFixed(2)}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ fontSize: 11, color: "#ccc" }}>
                      {new Date(order.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

// ─── App ─────────────────────────────────────────────────
export default function App() {
  const [page, setPage] = useState("home");
  const [cartCount, setCartCount] = useState(0);
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3200);
  };

  return (
    <AuthProvider>
      <Navbar page={page} setPage={setPage} cartCount={cartCount} />
      {page === "home" && <HomePage setPage={setPage} />}
      {page === "auth" && <AuthPage setPage={setPage} showToast={showToast} />}
      {page === "products" && <ProductsPage showToast={showToast} />}
      {page === "cart" && <CartPage setPage={setPage} showToast={showToast} setCartCount={setCartCount} />}
      {page === "orders" && <OrdersPage setPage={setPage} showToast={showToast} />}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </AuthProvider>
  );
}
